import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

export const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/louishinohara" },
  { Social: <FaGithub />, link: "https://github.com/louishinohara" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/louishinohara/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/louishinohara/" },
  { Social: <FaTwitter />, link: "https://twitter.com/louishinohara" },
];

const Social = () => {
  return (
    <div className="nav social-icons justify-content-center">
      {SocialShare.map((val, i) => (
        <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
          {val.Social}
        </a>
      ))}
    </div>
  );
};

export default Social;
